module.exports = __webpack_public_path__ + "img/touch.17be4bd7.jpg";